import React from "react";

function Modal({ onClose, results, data, correct }) {
  console.log(correct, results);
  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-header">
          <p className="modal-card-title">Your Answers</p>
          <button className="delete" onClick={onClose}></button>
        </header>
        <section className="modal-card-body content">
          <ul>
            {results.map((result, i) => (
              <li key={i} className="mb-6">
                <p>
                  {" "}
                  <strong> {result.q} </strong>{" "}
                </p>
                <p
                  className={
                    result.a == correct[i]
                      ? "has-background-success has-text-white p-2"
                      : "has-background-danger has-text-white p-2"
                  }
                >
                  Your answer: {result.options[result.a - 1]}
                </p>
                {result.a !== correct[i].toString() && (
                  <p className="has-background-link has-text-white p-2">
                    Correct Answer : {result.options[correct[i] - 1]}
                  </p>
                )}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
export default Modal;
